module.exports = __webpack_public_path__ + "static/dig-logo-05df81cf0b3457f4daeb42c7656873ac.png";